import { render } from "./formularioVerificacionTelefono.vue?vue&type=template&id=e1f8f30c"
import script from "./formularioVerificacionTelefono.vue?vue&type=script&lang=js"
export * from "./formularioVerificacionTelefono.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__